import React, { useContext } from 'react';
import { Box } from '@mui/material';

import { Card, Typography } from '@occc/ui-design-system';

import LocationSiteInfo from './LocationSiteInfo';
import CarWash from './CarWash';
import Fuel from './Fuel';

import { LocationContext } from '../LocationProvider';

const LocationSiteControllerContainer: React.FC = () => {
  const { loading, location } = useContext(LocationContext);
  if (!location || !location.siteSystemConfiguration || !location.siteSystemConfiguration.length) {
    return (
      <Card sx={{ p: 2 }}>
        <Typography color='primary'>No Site information.</Typography>
      </Card>
    );
  }

  const siteConfiguration = location.siteSystemConfiguration[0];
  const siteDetails = siteConfiguration.details;

  return (
    <>
      <LocationSiteInfo
        identifier={siteConfiguration.identifier}
        siteDetails={siteDetails!}
        lastConnection={siteDetails ? siteDetails.lastConnection || undefined : undefined}
        timezone={location.timezone}
        loading={loading}
      />
      <Box my={1}>
        <CarWash
          carWashItems={(siteDetails && siteDetails.carWashDetails) || undefined}
          loading={loading}
        />
      </Box>
      <Box my={1}>
        <Fuel
          fuelItems={(siteDetails && siteDetails.fuelConfigDetails) || undefined}
          loading={loading}
        />
      </Box>
    </>
  );
};

export default LocationSiteControllerContainer;
